<template>
  <div class="pwebCommonModal ">
    <div ref="commonCodeModal" class="modal fade" id="commonCodeModal" tabindex="-1" role="dialog" aria-labelledby="commonCodeModal" aria-hidden="true">
      <div class="modal-dialog modal-lg m-10" role="document">
        <div class="modal-content">
          <div class="modal-body modal-padding p-48">
            <div class="text-center">
              <label v-if="title" class="code-modal-title">{{ title }}</label>
              <p v-if="helpText" class="code-modal-help-text" v-html="helpText"></p>
            </div>
            <div class="d-flex justify-content-center pt-10">
              <div v-if="cancelButton" class="col-6 col-md-6">
                <button data-dismiss="modal" class="btn leavestudy" @click="cancelBtnCallback">
                  {{ cancelButton }}
                </button>
              </div>
              <div v-if="okButton" class="discard-btn" :class="cancelButton ? 'col-6 col-md-6' : 'col-12 col-md-12'">
                <button class="btn leave_study_cntue primary-bg" data-dismiss="modal" @click="callbackFunction">
                  {{ okButton }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "participant-web-modal",
  props: ["title", "helpText", "cancelButton", "okButton", "show"],
  data() {
    return {};
  },
  watch: {
    show() {
      const element = this.$refs.commonCodeModal;
      $(element).modal("show");
    }
  },
  mounted() {
    if (this.show) {
      const element = this.$refs.commonCodeModal;
      $(element).modal("show");
    }
  },
  methods: {
    callbackFunction() {
      this.$emit("modalCallback", true);
    },
    cancelBtnCallback() {
      this.$emit("cancelled", true);
    }
  }
};
</script>

<style>
.code-modal-title {
  margin: 0 0 32px;
  font-family: Roboto;
  font-size: 36px;
  font-weight: 300;
  line-height: 0.94;
  text-align: center;
  color: #4a4a4a;
}

.code-modal-help-text {
  flex-grow: 0;
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.31;
  letter-spacing: -0.32px;
  text-align: center;
  color: #4a4a4a;
}

.modal-dialog {
  min-width: 540px !important;
}
</style>
